import React, { useState, createContext } from 'react';

type LanguageContextType = {
    language: string;
    setLanguage: React.Dispatch<React.SetStateAction<string>>;
};

export const LanguageContext = createContext<LanguageContextType>({
    language: '',
    setLanguage: () => {},
});
interface LanguageProviderProps{
    children: React.ReactNode;
}
// add children type of react children
export const LanguageProvider = ({ children }:LanguageProviderProps) => {
    const [language, setLanguage] = useState('English');

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
// what is the react childern type?
// https://stackoverflow.com/questions/47914536/what-is-the-react-children-type
